module.exports = __webpack_public_path__ + "img/d79df0f08f8847c59e996e2db29141ec.dde295a8.jpg";